(function($) {
    $('.sponsors--scroll').slick({
        arrows: true,
        dots: false,
        infinite: false,
        pauseOnHover: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow: `<button class="slick-arrow slick-prev"><svg width="8px" height="14px" viewBox="0 0 8 14" fill="#ffffff">
                        <g transform="translate(-8.000000, -5.000000)">
                        <path d="M15.7071068,5.29289322 C15.3466228,4.93240926 14.7793918,4.90467972 14.3871006,5.20970461 L14.2928932,5.29289322 L8.29289322,11.2928932 C7.93240926,11.6533772 7.90467972,12.2206082 8.20970461,12.6128994 L8.29289322,12.7071068 L14.2928932,18.7071068 C14.6834175,19.0976311 15.3165825,19.0976311 15.7071068,18.7071068 C16.0675907,18.3466228 16.0953203,17.7793918 15.7902954,17.3871006 L15.7071068,17.2928932 L10.415,12 L15.7071068,6.70710678 C16.0675907,6.34662282 16.0953203,5.77939176 15.7902954,5.38710056 L15.7071068,5.29289322 Z"></path>
                        </g>
                    </svg></button>`,
        nextArrow: `<button class="slick-arrow slick-next"><svg width="8px" height="14px" viewBox="0 0 8 14" fill="#ffffff">
                        <g transform="translate(-8.000000, -5.000000)">
                        <path d="M8.29289322,5.29289322 C8.65337718,4.93240926 9.22060824,4.90467972 9.61289944,5.20970461 L9.70710678,5.29289322 L15.7071068,11.2928932 C16.0675907,11.6533772 16.0953203,12.2206082 15.7902954,12.6128994 L15.7071068,12.7071068 L9.70710678,18.7071068 C9.31658249,19.0976311 8.68341751,19.0976311 8.29289322,18.7071068 C7.93240926,18.3466228 7.90467972,17.7793918 8.20970461,17.3871006 L8.29289322,17.2928932 L13.585,12 L8.29289322,6.70710678 C7.93240926,6.34662282 7.90467972,5.77939176 8.20970461,5.38710056 L8.29289322,5.29289322 Z"></path>
                        </g>
                    </svg></button>`,
        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1080,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 770,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1,
                }
            }
        ],
    })
})(jQuery)